import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { SIZES } from '../styles/theme'
import EntrancePages from '../containers/EntrancePages'
import { fixedAssets } from 'src/containers/PreCache'

const Page = styled.div`
  min-height: 100vh;
  width: 100vw;
  text-align: center;

  #content {
    position: absolute;
    top: 0;
    width: 100%;
  }

  #header {
    padding-top: 3vh;
    background: #1e1945;

    h1 {
      color: #fff;
      font-weight: 600;
      letter-spacing: 1px;
      margin-bottom: 0.8em;
      font-size: 1.65rem;
    }

    .time-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      text-transform: uppercase;

      .time-card {
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        background: rgb(255, 255, 255);
        background: linear-gradient(rgba(255, 255, 255, 1) 0%, rgba(242, 241, 241, 1) 70%, rgba(180, 179, 179, 1) 100%);

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        min-width: 120px;
        width: 10vw;
        margin: 0 1%;
        margin-top: 5px;
        padding-top: 10px;

        ${SIZES.mobile} {
          border-radius: 14px;
          border: 4px solid white;
          margin: 0 20px;
          margin-bottom: 10px;
        }

        p {
          margin-bottom: 6px;
          font-weight: 500;
        }

        h2 {
          font-weight: 700;
          font-size: 3.2rem;
        }
      }
    }
  }
  #bg {
    background-image: url(${fixedAssets.regBg});
    background-size: cover;
    background-position: top center;
    bottom: 0;
    padding: 0;
    min-height: 100%;
    position: relative;

    .portrait {
      display: none;
    }
    .landscape {
      display: block;
    }
    .title {
      position: absolute;
      top: 40%;
      transform: translateY(-40%);
    }
    .visual {
      position: absolute;
      width: 15%;
      animation: floating 4s infinite linear;
    }
    #growth {
      top: 15%;
      left: 5%;
    }
    #comfort {
      top: 5%;
      left: 45%;
    }
    #cognition {
      top: 20%;
      left: 80%;
    }
    #bgM {
      position: absolute;
      top: 0;
      left: 0;
    }
    ${SIZES.mobile} {
      padding: 0;

      .visual {
        width: 35%;
      }
      #comfort {
        left: 40%;
      }
      #cognition {
        left: 55%;
      }
      img.portrait {
        display: block;
        margin: 0 auto;
      }
      img.landscape {
        display: none;
      }
    }
  }
`

export default function CountdownPage() {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = config.EVENT_START_TIME
    const difference = +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
  })

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    timerComponents.push(
      <div className="time-card" key={interval}>
        <p>{interval}</p>
        <h2>{timeLeft[interval]}</h2>
      </div>
    )
  })

  const eventStarted = !timerComponents.length

  if (eventStarted) {
    return <EntrancePages />
  }

  return (
    <Page>
      <div id="content">
        <div id="header">
          <h1>{config.eventName}</h1>
          <div className="time-wrapper">
            {timerComponents.length && timerComponents}
          </div>
        </div>
        <div id="bg">
          <img className="landscape" src={fixedAssets.regBg} width="100%" alt="background" />
          <img className="landscape title" src={fixedAssets.kvTitle} width="100%" alt="kv title" />
          <img className='portrait' src={fixedAssets.regBgM} width="100%" alt="kv title" />
          <img className='portrait title' src={fixedAssets.kvTitleM} width="100%" alt="kv title" />
          <img id="growth" className='visual' src={fixedAssets.growth} alt="visual" />
          <img id="comfort" className='visual' src={fixedAssets.comfort} alt="visual" />
          <img id="cognition" className='visual' src={fixedAssets.cognition} alt="visual" />
        </div>
      </div>
    </Page>
  )
}
